import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuth";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grain bg-ink text-white flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img src="/mc-logo.png" alt="Ms Chancellor" className="h-16 w-16 object-contain mx-auto" />
          <h1 className="mt-5 font-serif text-3xl font-light">Admin Portal</h1>
          <p className="text-white/40 text-xs uppercase tracking-[0.3em] mt-2">Ms Chancellor Entertainment</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-6 border border-gold/20 rounded-sm p-8 bg-[#0b0b0b]">
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-white/40">Email</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" data-testid="admin-email"
              className="w-full bg-transparent border-b border-white/20 py-3 focus:border-gold focus:outline-none" />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-white/40">Password</label>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" data-testid="admin-password"
              className="w-full bg-transparent border-b border-white/20 py-3 focus:border-gold focus:outline-none" />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full py-4 bg-gold text-black text-xs uppercase tracking-[0.25em] rounded-sm hover:bg-gold-light transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
